/**
 * Helper utility to determine API URL prefix based on environment
 * 
 * In production, the API is accessed via /api/ prefix due to IIS configuration
 * In development, the API controllers don't have api/ in their route attributes
 */

export const getApiPrefix = () => {
  return process.env.NODE_ENV === 'production' ? '/api/' : '/';
};
